import { getRequest, postRequest } from "../system/server-call";
import responseHandler from "../system/server-response-handler";

const getRefundOrders = (id) => {
  return getRequest(`order/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getProductsByOrderId = (id) => {
  return getRequest(`orders/${id}/products`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getCustomerById = (id) => {
  return getRequest(`customer/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const addRefundOrder = (data , id) => {
  return postRequest(`payment/refund/${id}`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const refundOrderService = {
  getRefundOrders,
  getProductsByOrderId,
  getCustomerById,
  addRefundOrder,
};
